module.exports = __webpack_public_path__ + "static/kioskAbout-ab49e466e578780caace3d1d9ebeb41b.png";